import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          The second part of the solution addressed the problem of data processing. As Chan puts it,
          “Better decision-making will lead to many things—saving labor, driving sustainability, and
          generating larger yields. We do believe data will transform the operation.” The burning
          question was how Intel could support a technology solution that worked in the field, where
          the farmers needed it, and allowed them to generate data analytics quickly, so they could
          tweak their operations in real time.
        </p>
        <p className="chapter__paragraph">
          In collaboration with Intel, Bluewhite tackled these issues through a proof-of-concept
          pilot at one of its farms in California.
        </p>
      </section>
    </>
  );
}

export default Chapter5;
